import store from '../store'

export default function advertiser (to, from, next) {
  if (store.state.user.profile.type !== 'advertiser') {
    return next({
      name: 'home'
    })
  }

  return false
}
